import "./Footer.css";

const Footer = () => {
  return (
    <></>
  );
};

export default Footer;
